module.exports = __webpack_public_path__ + "assets/img/haiwaicang.35574d45.png";